export default {
    select: "Vyberte dodací adresu",
    shippingRulesTip: "Musíte dodržovat místní pravidla pro přepravu"
}